export default __webpack_public_path__ + "static/media/5.97116a2e.jpeg";